import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React from 'react';
import { func, node, number, oneOf, oneOfType, string } from 'prop-types';
import { useListContext } from './list-context';
import withWrapper from './withWrapper';
import { Item } from './list.styles';

const ListHeader = _ref => {
  let {
    as,
    children
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["as", "children", "onClick"]);

  const {
    variant,
    scale,
    gutters
  } = useListContext();
  return /*#__PURE__*/React.createElement(Item, _extends({
    forwardedAs: as,
    variant: variant,
    scale: scale,
    gutters: gutters,
    "data-testid": "list-header"
  }, props), children);
};

process.env.NODE_ENV !== "production" ? ListHeader.propTypes = {
  as: string,
  children: node,
  fontSize: number,
  fontWeight: oneOfType([string, number]),
  variant: oneOf(['light', 'primary', 'transparent', 'base']),
  onClick: func
} : void 0;
ListHeader.defaultProps = {
  children: null,
  fontSize: 2,
  fontWeight: 'medium'
};
ListHeader.displayName = 'ListHeader';
export default withWrapper(ListHeader);